export const defaultPublicTrackingUrl = "/public/tag_owners/@tag_owner_id@/clicked_hotspots"